<template>
    <div class="container-fluid" v-if="!this.$store.state.preloader">
        <div class="text-center">
            <h1>{{ $t("general.forgot_password.title") }}</h1>
        </div>
        <div class="row" v-if="this.showEmail">
            <div class="login-content mt-5">
                <div class="row content">
                    <div class="col-sm-12 mt-3">
                        <div class="form-group">
                            <label for="email">{{ $t("auth.login.email") }}</label>
                            <input @keyup.enter="sendEmail" v-validate="'required|email'" v-model="fields.email" name="email" id="email" type="text" required class="form-control {'input': true, 'is-danger': errors.has('email') }" />
                            <span class="text-danger" v-if="errors.has('email')">{{errors.first('email')}}</span>
                        </div>
                    </div>

                    <div class="footer">
                        <button @click="sendEmail" :disabled="errors.any() || !this.fields.email || $store.state.ajax_in_progress" class="float-left btn btn-success"><i class="fa fa-envelope-o" aria-hidden="true"></i> {{$t('general.forgot_password.send')}}</button>

                        <button class="float-right btn btn-secondary">
                            <i class="fa fa-arrow-circle-left" aria-hidden="true"></i> <router-link tag="a" to="/login" class="text-white">{{ $t("general.forgot_password.login") }}</router-link>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" v-if="!this.showEmail">
            <div class="login-content mt-5">
                <div class="row content">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label for="password">{{ $t("auth.login.password") }}</label>
                            <input @keyup.enter="changePassword" v-validate="'required'" ref="password" v-model="fields.password" name="password" id="password" type="password" required placeholder="Password" class="form-control" minlength="4" maxlength="10" />
                            <span class="text-danger" v-if="errors.has('password')">{{errors.first('password')}}</span>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label for="password_verif">{{ $t("general.forgot_password.confirm_password") }}</label>
                            <input @keyup.enter="changePassword" v-validate="'required|confirmed:password'" v-model="fields.password_verif" name="password_verif" id="password_verif" type="password" required placeholder="Confirm Password" class="form-control" minlength="4" maxlength="10" />
                            <span class="text-danger" v-if="errors.has('password_verif')">{{$t("errors.password.match")}}</span>
                        </div>
                    </div>
                    <div class="footer">
                        <div class="form-group text-center m-0">
                            <input :disabled="errors.any() || !this.fields.password || !this.fields.password_verif || $store.state.ajax_in_progress" type="submit" @click="changePassword" :value="$t('general.forgot_password.button')"  class="btn btn-success" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue';
    import http from '@/libs/http';
    import VeeValidate from 'vee-validate';
    import {vee_config} from '@/constants';
    import miniToastr from 'mini-toastr';

    Vue.use(VeeValidate, vee_config);

    export default {
        components: {},
        name: 'forgot_password_page',

        data() {
            return {
                counter: 0,
                fields: {},
                showEmail: 1
            }
        },
        created: function() {
        },
        computed: {
            user() {
                return this.$store.state.user;
            },
        },
        watch: {
            user: {
                immediate: true,

                handler(newVal, oldVal) {
                }
            },
        },
        created: function() {
            this.fields.code=this.$route.query.reset;
            if(this.fields.code==null)
                this.showEmail = 1;
            else {
                let data = http.route('forgot_password/show').post({
                    code: this.fields.code,
                    }, true);
                    data.then(response => {
                        if(response.isError) {
                            this.showEmail = 1;
                            if(response.errorMessage.error=='inexistent') {
                                this.errorMsg(Vue.i18n.translate('messages.code_inexistent'));
                                this.$router.push('forgotpassword');
                            }
                            if(response.errorMessage.error=='expired') {
                                this.errorMsg(Vue.i18n.translate('messages.code_expired'));
                                this.$router.push('forgotpassword');
                            }
                        } else {
                            this.showEmail = 0;
                        }
                    });
            }
        },
        mounted: function () {
            const jwt = sessionStorage.getItem('jwt');
            if (this.$store.state.user.user || jwt) {
                this.$router.push('/');
            }
        },
        updated: function(){
            const {user} = this.$store.state.user;
            if (user) {
                this.$router.push({path: '/'});
            }
        },
        methods: {
            successMsg(msg) {
                miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
            },
            errorMsg(msg) {
                miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
            },
            sendEmail () {
                let data = http.route('forgot_password').post({
                   email: this.fields.email
                }, true);
                data.then(response => {
                    if(response.isError)
                        if(response.errorMessage.error=='resendCooldown')
                            this.errorMsg(Vue.i18n.translate('messages.resend_cooldown'));
                        else
                            this.errorMsg(Vue.i18n.translate('errors.email.notRegistered'));
                    else
                        this.successMsg(Vue.i18n.translate('messages.email_sent'));
                });
            },
            changePassword() {
                let data = http.route('forgot_password').post({
                   code: this.fields.code,
                   password: this.fields.password
                }, true);
                data.then(response => {
                    if(response.isError) {
                        this.errorMsg(Vue.i18n.translate('messages.error_reset'));
                        this.showEmail = 1;
                        this.$router.push('/forgotpassword');
                    } else {
                        this.successMsg(Vue.i18n.translate('messages.password_changed'));
                        this.$router.push('/login');
                    }
                });
            }
        }
    }
</script>

<style scoped>
    h1 {
        margin: auto;
        text-align: center;
    }
    .container-fluid {
        margin-top: 10%;
    }
    .btn.btn-success {
        font-size: 20px;
        border-radius: 5px;
    }
    .mt-5, .my-5 {
        margin-top: 1rem !important;
    }
    .login-content {
        padding: 20px;
        box-shadow: 0 0 20px #ccc;
        background-size: 100% 100%;
        border-radius: 7px;
        max-width: 30% !important;
        margin: auto;
        overflow: hidden;
    }
    .footer {
        width: 100%;
        margin: 0px 16px 10px 16px;
    }
    .btn {
        padding: 5px 12px;
        font-size: 14px !important;
    }
    .img_backgrond{
        background-size:cover;
        background-repeat:no-repeat;
        width: 100%;
        padding: 75px 15px;
    }
    label{
        font-size: 14px !important;
    }
    ::-webkit-input-placeholder {
        font-size:14px;
    }

    @media screen and (min-width: 1200px) {
        .login-content {
            width: 400px;
            max-width: 95% !important;
            margin: auto;
            overflow: hidden;
        }
    }

    @media screen and (max-width: 1200px) {
        .login-content {
            width: 400px;
            max-width: 95% !important;
            margin: 0 auto;
            overflow: hidden;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/authentication/forgot_password_page.vue